const Style = {
    container: 'flex flex-col justify-center items-center pt-24 pb-4',
    title: 'text-3xl font-semibold mt-4 mb-8',

}

export default Style